import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPaymentFailed(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m67.534 93.403-1.098-18.39 8.678-18.82-.431-9.776 31.008 6.316a3.956 3.956 0 0 1 3.087 4.666l-7.895 38.76a3.955 3.955 0 0 1-4.665 3.087l-28.684-5.843Z"
        fill="#78B441"
      />
      <path
        d="m67.534 93.403-1.098-18.389 8.677-18.82-.43-9.776-.515-.04a.593.593 0 0 0-.639.617l.401 9.106-8.677 18.82 1.068 17.874c.017.296.25.532.545.556l.668.052Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m74.913 51.633 5.972-3.952-6.202-1.263.23 5.215Zm-7.648 37.255 40.566-26.837.948-4.651a3.956 3.956 0 0 0-3.087-4.666l-2.325-.474-36.834 24.368.732 12.26Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m71.03 65.05 34.749 7.078 1.895-9.303-32.56-6.632-4.084 8.857Z"
        fill="#0F172A"
      />
      <path
        d="M81.769 82.981a3.56 3.56 0 0 1 4.198-2.778l4.651.947a3.56 3.56 0 0 1-1.42 6.978l-4.652-.947a3.561 3.561 0 0 1-2.777-4.2Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m59.732 90.016-9.22-15.95-.672-20.713-4.764-8.548-30.552 8.243a3.956 3.956 0 0 0-2.789 4.85l10.304 38.19a3.956 3.956 0 0 0 4.85 2.79l32.843-8.862Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m45.076 44.806 2.541 4.56-2.983 5.187a4.196 4.196 0 0 1-7.275-4.183l2.37-4.122 5.347-1.442Zm6.245 30.66L57.468 86.1l-3.082 5.36-14.513 3.915 11.448-19.907Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m49.84 53.353.317 9.747-34.506 9.31-2.473-9.165 36.662-9.892Z"
        fill="#0F172A"
      />
      <path
        d="M41.747 82.577 30.29 85.669a1.186 1.186 0 1 0 .618 2.291l11.457-3.092a1.186 1.186 0 1 0-.618-2.291Z"
        fill="#00664F"
      />
      <path
        d="M41.747 82.577a1.187 1.187 0 0 1 .619 2.291L30.908 87.96l-.119.026a1.188 1.188 0 0 1-.614-2.28l.115-.037 11.457-3.092Zm.194.72-11.457 3.091a.44.44 0 1 0 .23.852l11.457-3.09.001-.001a.44.44 0 0 0-.143-.866l-.088.014ZM45.093 76.758l-16.04 4.327a1.187 1.187 0 0 0 .619 2.291l16.04-4.327a1.187 1.187 0 1 0-.619-2.291Z"
        fill="#00664F"
      />
      <path
        d="M45.094 76.757a1.187 1.187 0 0 1 .618 2.292l-16.04 4.327a1.187 1.187 0 0 1-.619-2.291l16.04-4.328Zm.194.72-16.04 4.328a.441.441 0 0 0 .23.852l16.04-4.327a.441.441 0 0 0 .325-.453l-.015-.089a.44.44 0 0 0-.54-.31Z"
        fill="#00664F"
      />
      <path
        d="M60.077 62.863c2.02.283 3.857-1.357 4.104-3.664.248-2.308-1.187-4.408-3.206-4.69-2.019-.284-3.856 1.356-4.104 3.664-.248 2.307 1.188 4.407 3.206 4.69ZM57.895 26.299c-.009-3.93 3.59-6.978 7.673-6.5 4.083.48 6.802 4.269 5.798 8.08l-4.785 18.167c-.54 2.05-2.593 3.395-4.79 3.137-2.196-.257-3.848-2.037-3.853-4.151l-.043-18.733Z"
        fill="#FC0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPaymentFailed)
